import React from 'react';
import {Icon} from '../Icon/Icon';
import './styles.css';

interface Props {
  title: string;
  subtitle: string;
  /** The title's element: a heading when the empty state stands in for a page section. */
  titleAs?: 'h2' | 'h3' | 'p';
}

const MicroreelsEmptyState = ({title, subtitle, titleAs = 'p'}: Props) => {
  const Title = titleAs;
  return (
    <div className="EmptyStateContainer">
      <Icon name="microreel.svg" className="SpanIcon" />
      <Title className="Title">{title}</Title>
      <p className="Title">{subtitle}</p>
    </div>
  );
};

export default MicroreelsEmptyState;
